import { getOr } from 'lodash/fp';
import AnalyticsConstants from '../../../analytics/constants';

const primaryCategory = getOr(AnalyticsConstants.PrimaryCategories.Overlay, 'thdAnalyticsEvent.category.primaryCategory', window);
const eventName = getOr(AnalyticsConstants.EventNames.InstallationSummaryModal, 'thdAnalyticsEvent.eventInfo.eventName', window);


export default () => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory,
    },
    eventInfo: {
      eventName,
    },
  };
  // eslint-disable-next-line no-undef
  if (_T.sendEventDataToAnalytics) {
    // eslint-disable-next-line no-undef
    _T.sendEventDataToAnalytics(thdAnalyticsEvent);
  }
};

